__turbopack_context__.v({
  "embla": "EmblaCarousel-module__OjaXZG__embla",
  "emblaButtonContainer": "EmblaCarousel-module__OjaXZG__emblaButtonContainer",
  "emblaContainer": "EmblaCarousel-module__OjaXZG__emblaContainer",
  "emblaItem": "EmblaCarousel-module__OjaXZG__emblaItem",
  "emblaItemStretchHeight": "EmblaCarousel-module__OjaXZG__emblaItemStretchHeight",
  "pipNumbers": "EmblaCarousel-module__OjaXZG__pipNumbers",
  "pips2026": "EmblaCarousel-module__OjaXZG__pips2026",
  "pips2026lighter": "EmblaCarousel-module__OjaXZG__pips2026lighter",
  "selected": "EmblaCarousel-module__OjaXZG__selected",
});
